<template>
  <div
    class="reviews-leave-btn flex-shrink-0"
    :class="{ 'w-100': isMobile }"
  >
    <CorePRG
      :class="{ 'w-100': isMobile }"
      :url="newRateUrl"
      :form-attrs="formAttrs"
      :button-attrs="buttonAttrs"
    >
      {{ tStatic('Оставить отзыв') }}
    </CorePRG>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

const props = defineProps<{
  lpuId: number
}>()

const isMobile = useIsMobile()

const { urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const newRateUrl = reverseFullL10N({
  name: 'newrate_lpu',
  args: {
    language: urlLang,
    object_id: String(props.lpuId),
  },
})

const formAttrs = {
  target: '_self',
  'data-google-goal': 'click_leave_review_free',
}

const buttonAttrs = computed(() => ({
  class: `reviews-leave-btn__control branding-btn branding-btn--primary rounded-20 text-subtitle-1${isMobile.value ? ' w-100' : ''}`,
  'data-qa': 'lpu_reviews_leave_btn',
}))
</script>

<style scoped lang="scss">
.reviews-leave-btn {
  ::v-deep .reviews-leave-btn__control {
    border: 0;
    cursor: pointer;
    height: 52px;
    padding: 8px 16px;
  }
}
</style>
